import * as actionType from '../constants/Auth';
import {
  AUTHENTICATED,
  HIDE_AUTH_MESSAGE,
  SHOW_AUTH_MESSAGE,
  SHOW_LOADING,
  SIGNIN,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SIGNUP,
  TEAMS_USER_CREDENTIAL
} from '../constants/Auth';

export const signIn = (user) => {
  return {
    type: SIGNIN,
    payload: user
  }
};

export const authenticated = (token) => {
  return {
    type: AUTHENTICATED,
    token
  }
};

export const setTeamsUserCredential = (teamsUserCredential) => {
  return {
    type: TEAMS_USER_CREDENTIAL,
    teamsUserCredential
  }
};

export const signOut = () => {
  return {
    type: SIGNOUT
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  }
};

export const signUp = (user) => {
  return {
    type: SIGNUP,
    payload: user
  };
};



export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = () => {
  return {
    type: SHOW_LOADING,
  };
};



const createActionSet = (type) => {
  return {
    request: (payload) => ({type: `${type.REQUEST}`, payload}),
    success: (payload) => ({type: `${type.SUCCESS}`, payload}),
    failure: (payload) => ({type: `${type.FAILURE}`, payload}),
  }
}


export const handleLoginGetWay = createActionSet(actionType.LOGIN_GETWAY)
export const resetAuth = createActionSet(actionType.RESET_AUTH)


